import { createContext, useContext } from "react";
var context = /*#__PURE__*/ createContext();
export function useProfileContext() {
    return useContext(context);
}
export default context;

//# sourceMappingURL=context.js.map